import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import ScrollToTop from '@/components/layout/ScrollToTop';
import { Helmet } from 'react-helmet';

export default function PrivacyPolicy(){
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Helmet>
        <title>سياسة الخصوصية - New Business</title>
        <meta name="description" content="سياسة الخصوصية لموقع New Business، وشرح كيفية جمع ومعالجة البيانات." />
      </Helmet>

      <main className="container mx-auto px-4 py-16">
        <h1 className="text-2xl font-bold mb-4">سياسة الخصوصية</h1>

        <p className="mb-4">نحترم خصوصيتك. هذه السياسة تشرح أنواع البيانات التي نجمعها وكيف نستخدمها ونحميها.</p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">المعلومات التي نجمعها</h2>
          <ul className="list-disc list-inside text-muted-foreground">
            <li>معلومات الاتصال التي تقدمها عند التواصل معنا.</li>
            <li>بيانات الاستخدام والسلوك على الموقع (تحليلات مجهولة).</li>
            <li>ملفات تعريف الارتباط وقد تُستخدم لأغراض التحليل والتحسين.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">كيفية استخدامنا للبيانات</h2>
          <p className="text-muted-foreground">نستخدم البيانات لتحسين الخدمة، للاتصال مع العملاء، ولأغراض تسويقية إذا وافق المستخدم.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">الكوكيز والتحليلات</h2>
          <p className="text-muted-foreground">نستخدم أدوات تحليلية قابلة للإيقاف عبر إعدادات الخصوصية. يمكن للمستخدم سحب الموافقة في أي وقت عبر صفحة إعدادات الخصوصية.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">حقوقك</h2>
          <p className="text-muted-foreground">لديك الحق في الوصول إلى بياناتك، طلب تصحيحها، أو سحب موافقتك حيثما ينطبق ذلك.</p>
        </section>

        <p className="text-sm text-muted-foreground mt-8">آخر تحديث: 17 ديسمبر 2025</p>
      </main>

      <Footer />
    </>
  );
}
